export const AppHomeBannerFallback = [
  {
    image: '/images/home-banner/kv-casino.png',
    type: 'casino',
  },
  {
    image: '/images/home-banner/kv-evolution.webp',
    type: 'evolution',
  },
  {
    image: '/images/home-banner/kv-hotroad.webp',
    type: 'hotroad',
  },
  {
    image: '/images/home-banner/kv-JDB-e-game.webp',
    type: 'jdb-e-game',
  },
  {
    image: '/images/home-banner/kv-netent.webp',
    type: 'netent',
  },
  {
    image: '/images/home-banner/kv-smartsoft.webp',
    type: 'smartsoft',
  },
];

export const AppWelcomebannerFallback = [
  { type: 'appWelcomeBanner', image: '/images/home/app-welcome.png' },
];
